import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { resetPassword } from "../api/client";
import BackgroundAnimation from "../components/BackgroundAnimation";
import "../auth.css";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [form, setForm]       = useState({ password: "", confirm: "" });
  const [token, setToken]     = useState("");
  const [email, setEmail]     = useState("");
  const [error, setError]     = useState("");
  const [info, setInfo]       = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      // Fallback manual hash parsing: e.g. "#/reset-password?token=...&email=..."
      const searchStr = window.location.hash.includes("?") 
        ? window.location.hash.split("?")[1] 
        : window.location.search;
        
      const params = new URLSearchParams(searchStr);
      const tokenParam = params.get("token");
      const emailParam = params.get("email");
      
      if (tokenParam && emailParam) {
        setToken(tokenParam);
        setEmail(emailParam);
      } else {
        setError("Invalid or expired password reset URL. Please request a new link.");
      }
    } catch (e) {
      setError("Failed to parse reset credentials.");
    }
  }, [location]);

  const handleSubmit = async () => {
    if (!form.password || !form.confirm) { setError("All fields required"); return; }
    if (form.password !== form.confirm) { setError("Passwords do not match"); return; }
    if (form.password.length < 6) { setError("Password must be at least 6 characters"); return; }
    setLoading(true); setError(""); setInfo("");
    try {
      const data = await resetPassword({ email, token, new_password: form.password });
      setInfo(data.message || "Password reset successfully!");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to reset password. Link may have expired.");
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <BackgroundAnimation />
      <div className="auth-card">
        <div className="auth-brand">
          PINE<span className="accent">CONNECTOR</span>
        </div>
        <div className="auth-title">
          Reset Password
        </div>
        <div className="auth-sub">
          {email ? `Enter a new password for ${email}` : "Recover access to your account"}
        </div>

        {error && (
          <div className="auth-error">{error}</div>
        )}
        
        {info && (
          <div className="auth-info" style={{ color: "var(--green)", background: "rgba(16, 185, 129, 0.08)", border: "1px solid rgba(16, 185, 129, 0.2)", padding: "10px", borderRadius: "var(--radius)", fontSize: "13px", marginBottom: "16px", fontWeight: "500", textAlign: "center" }}>
            {info}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">New Password</label>
          <input
            type="password"
            className="form-input"
            placeholder="Min 6 characters"
            disabled={!token || !email || loading}
            value={form.password}
            onChange={e => setForm(p => ({...p, password: e.target.value}))}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Confirm New Password</label>
          <input
            type="password"
            className="form-input"
            placeholder="Repeat new password"
            disabled={!token || !email || loading}
            value={form.confirm}
            onChange={e => setForm(p => ({...p, confirm: e.target.value}))}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
          />
        </div>

        <button
          className="btn btn-primary"
          style={{ width: "100%", marginTop: 8 }}
          onClick={handleSubmit}
          disabled={!token || !email || loading}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>

        <div className="auth-footer" style={{ marginTop: "24px" }}>
          <Link to="/login">Back to Sign in</Link>
        </div>
      </div>
    </div>
  );
}
